var moduleMap = {
	"./ClinicalSummary": () => {
		return Promise.all([__webpack_require__.e(5697), __webpack_require__.e(3160), __webpack_require__.e(3286), __webpack_require__.e(2871), __webpack_require__.e(403), __webpack_require__.e(3845), __webpack_require__.e(5974), __webpack_require__.e(6550), __webpack_require__.e(2988), __webpack_require__.e(7271), __webpack_require__.e(7650), __webpack_require__.e(2950), __webpack_require__.e(4577), __webpack_require__.e(6677), __webpack_require__.e(4732)]).then(() => (() => ((__webpack_require__(695)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});